import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Params} from "@angular/router";
import {Location} from '@angular/common';

import {ApiService} from "../services/api.service";
import {DataService} from "../services/data.service";
import {CompanyStatus} from "../type/company-status";

@Component({
    selector: 'app-company-status-edit',
    templateUrl: './company-status-edit.component.html',
})
export class CompanyStatusEditComponent implements OnInit {

    node = 'company-status';
    companyStatus: CompanyStatus = CompanyStatus;

    constructor(private dataService: DataService,
                private apiService: ApiService,
                private route: ActivatedRoute,
                private location: Location) {
    }

    ngOnInit(): void {
        this.dataService.refresh();
        this.route.params
            .subscribe(
                (params: Params) => {
                    this.apiService.getUsingId(this.node, +params['id'])
                        .subscribe((response) => {
                            this.dataService.updateActiveRequestNo(-1);
                            this.companyStatus = response.json().data[0]
                        });
                }
            );
    }

    onFormSubmit() {
        this.apiService.update(this.node, [this.companyStatus.company_status_id], this.companyStatus)
            .subscribe((response) => {
                    this.dataService.updateActiveRequestNo(-1);
                    if (response.json().error == true) {
                        alert('Error: Unable to submit form');
                    } else {
                        alert('Success: Company Status updated successfully');
                        this.location.back();
                    }
                },
                (error) => alert('Error: Unable to submit form')
            );
    }

    checkPermission(module, method) {
        return this.dataService.checkPermission(module, method);
    }

}



// WEBPACK FOOTER //
// ./src/app/company-status/company-status-edit.component.ts